import initHelpers from '72cms-ui/helpers';
import env from '../../cms/js/config/base';

env.apiPrefix = 'api/filter-pro';
export default initHelpers(env);
